export default __webpack_public_path__ + "static/media/arrowLeftGreen.833da9c6.svg";